import { createAction, createAsyncAction, asyncTakeFirst } from 'react-async-client';

import { APP_RUN, LOGOUT, POST_REFRESH_TOKEN } from 'constants/actionTypes';
import { postRefreshTokenHandler } from './handlers';

export const appRun = createAction(APP_RUN);
export const logout = createAction(LOGOUT);

export const postRefreshToken = createAsyncAction(POST_REFRESH_TOKEN, postRefreshTokenHandler, {}, asyncTakeFirst);
